module.exports = __webpack_public_path__ + "img/BrainForce-newsroom.555539d5.jpg";